// extracted by mini-css-extract-plugin
export var container = "_g2-0";
export var segment = "_g2-2";
export var segmentActive = "_g2-3";
export var track = "_g2-1";